'use strict';

var api = require('./api');

api.populateGlobalFeatureSupport();
module.exports.getScaleToFitImageURL = api.getScaleToFitImageURL;
module.exports.getScaleToFillImageURL = api.getScaleToFillImageURL;
module.exports.getCropImageURL = api.getCropImageURL;
//# sourceMappingURL=index.js.map